import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import ServicesLanding from "../views/ServicesLanding";
import MedicalGasSystemsService from "../views/MedicalGasSystemsService";
import OxygenGenerator from "../views/OxygenGenerator";
import RadiologyEquipments from "../views/RadiologyEquipments";
import GasManifold from "../views/GasManifold";
import HeadUnit from "../views/HeadUnit";
import GasOutlet from "../views/GasOutlet";
import GasAlarm from "../views/GasAlarm";
import VacuumSystem from "../views/VacuumSystem";
import OxygenTherapy from "../views/OxygenTherapy";
import ModularOperatingTheatre from "../views/ModularOperatingTheatre";

export default function Services(props) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ServicesLanding/>
		} else if(
			appContext.navSubItem === 'medical_gas_systems' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <MedicalGasSystemsService/>
		} else if(
			appContext.navSubItem === 'oxygen_generator' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <OxygenGenerator/>
		} else if(
			appContext.navSubItem === 'radiology_equipments' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <RadiologyEquipments/>
		} else if(
			appContext.navSubItem === 'gas_manifold' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <GasManifold/>
		} else if(
			appContext.navSubItem === 'bed_head_unit' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <HeadUnit/>
		} else if(
			appContext.navSubItem === 'gas_outlet' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <GasOutlet/>
		} else if(
			appContext.navSubItem === 'gas_alarm' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <GasAlarm/>
		} else if(
			appContext.navSubItem === 'vacuum_system' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <VacuumSystem/>
		} else if(
			appContext.navSubItem === 'oxygen_therapy' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <OxygenTherapy/>
		} else if(
			appContext.navSubItem === 'operating_theatre' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ModularOperatingTheatre/>
		} 

		return null;
	}

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}